export const labels = {
  //Validation
  missingReferenceSheet:
    "Could not find worksheet 'Reference_sheet'. To try again, open EY Canvas Bulk Update Add-in in a new workbook.",
  descriptionError: "Description exceeds {0} character limit",
  titleMissingError: "Missing Title (required)",
  titlemaxLimitError: "Title exceeds {0} character limit",
  userNotFromSelectedGroup:
    "Request cannot be assigned to both a group and user",
  dueDateFormatError: "Invalid date format in Due date",
  fieldError:
    "Could not update EY Canvas, as some records had errors. Check the Status column for details.",
  invalidColumn: "Invalid data in {0}",
  requiredColumn: "{0}為必填",
  hashValueMissing: "更新EY Canvas需要Hash值。檢查此工作表中的列。",
  // Panel Headers
  engagement: "Engagement",
  select: "Select",
  numberOfRecords: "Number of records",
  dowanloadedOn: "Downloaded on",
  canvasUpdatesOn: "Sent to EY Canvas for processing",
  selectRecordsToUpdate: "Select records to update",
  atlasWorkpaperIndexFramework: "EY Atlas: Workpaper indexing framework",
  referenceOnly: "Reference only",
  columnsToUpdate: "Update these columns",
  dueDateRequired: "Due date required",
  requestNotAssignedError: "Assign the request to a group or user",
  infoText:
    "You cannot run EY Canvas Bulk Update Add-in on multiple sheets in the same workbook. To edit a new item or EY Canvas engagement, open this tool in a new workbook.",
  noUpdatesSaved: "No updates saved",
  dummyLocalizationText: "Dummy Localization Text",
  unexpectedApiFailure: "Unexpected API failure. Please try again.",
  titleLengthExceeded: "標題超出500個字元的上限",
  DescriptionLengthExceeded: "描述超出4000個字元的上限",
  canvasDataEditor: "Canvas data editor",
  selectanitemtoedit: "Select an option",
  editRequestMessage: "Which requests would you like to edit?",
  selectRequestStatus: "Select at least one request status",
  selectRequestErrorMessage: "Select at least one request status",
  sheetWithSameNameExist:
    "A sheet named Input_sheet_{0} already exists. Please rename the sheet to continue.",
  engagementIdNotFound:
    "Could not find the EY Canvas engagement. Check the Engagement ID and confirm you have access to open the EY Canvas engagement.",
  boundSheetAlreadyExist_1: "EY Canvas Bulk Update Add-in",
  boundSheetAlreadyExist_2: "does not work on this tab",
  selectAnOperation: "What would you like to do?",
  submit: "Submit",
  next: "Next",
  eyCanvasEngagement: "選擇案件",
  search: "Search",
  engagementNotSelected: "選擇案件",
  invalidEngagement: "選擇有效項目",
  back: "Back",
  noRecordsFound: "No records found",
  masterSheetNoteText:
    "Note: This sheet is required to use EY Canvas Bulk Update Add-in.",
  informationText: "This tool allows you to:",
  infoText1: "編輯EY Canvas檔案和任務名稱以完成標準化索引，並",
  infoText3: "在EY Canvas中建立和編輯其他項目",
  infoTextforonlyAddClientRequest: "Create client requests",
  yes: "是",
  no: "否",
  close: "Close",
  ownedByEngagement: "Owned by this engagement",
  sharedToEngagement: "Shared into this engagement",
  status: "Status",
  statusId: "Status ID",
  Continue: "Continue",
  updateCanvas: "更新EY Canvas",
  newDocumentName: "New document name",
  documentName: "Document name",
  fileExt: "File extension",
  shared: "Shared",
  docId: "Document ID",
  hash: "Hash",
  newPrefix: "New prefix",
  newSuffix: "New suffix",
  newTitle: "New title",
  taskPrefix: "Task prefix",
  taskSuffix: "Task suffix",
  taskTitle: "標題",
  taskType: "Task type",
  taskTitleEditable: "Task title editable",
  auditPhase: "審計階段",
  milestone: "Milestone",
  timePhase: "時間階段",
  taskId: "Task ID",
  populateMsg: "Populating records from EY Canvas",
  updatingCanvas: "Updating EY Canvas. <br /> This may take a few minutes.",
  loadingContent: "Loading content",
  filenameRequired: "File name is required",
  excelError: "Excel formula error. Fix and try again.",
  specialCharacters: "Document name cannot contain */:<>\\?|" + '"',
  sameDocumentNameError: "New and old document names are the same",
  docNameLimit: "Document name cannot exceed 115 characters",
  markValueInvalid: "Invalid value in 'Update EY Canvas'. Fix and try again.",
  docAndHashNull:
    "Document ID and/or Hash value needed to update EY Canvas. Check those columns in this worksheet.",
  help: "Help",
  entityNotSelected: "Select an option to continue",
  AssignedToGroupInputMessageTitle: "Select a group (optional)",
  AssignedToGroupInputMessageDescription:
    "To assign to a whole group, select a group and leave the next column empty.",
  AssignedToUserInputMessageTitle: "Select a user (optional)",
  AssignedToUserInputMessageDescription:
    "To assign to a specific user, select a user and leave the previous column empty. Users are listed by group.\n\nNote: All group members will be able to view the request.  If a user is in multiple groups, check you are selecting the correct dropdown option.",
  apiServerExceptionError:
    "An error occurred connecting to EY Canvas. Please try again. If the issue persists, contact the Help Desk",
  taskNameExceedsLimit:
    "Exceeds character limit (title: 500 characters; prefix/suffix: 50 characters)",
  taskTypeUpdateNotAllowed: "Task title cannot be edited for this task type",
  taskEmptyHashOrDocId:
    "Task ID and/or Hash value needed to update EY Canvas. Check those columns in this worksheet.",
  taskTitleRequiredError: "Task title is required",
  sameTaskNameError:
    "New and old task name (prefix, suffix, title) are the same",
  universalUserPreferenceGetError:
    "User preference error occurred connecting to EY Canvas. Please try again. If the issue persists, contact the Help Desk",
  sameWorkbookMultipleSessionsError:
    "You cannot run multiple editing sessions within the same workbook. To edit a new item or EY Canvas engagement, open this tool in a new workbook.",
  errorMessageOnExcelUpdate:
    "Could not update EY Canvas, as some records had errors. Check the<b> Status </b>column for details.",
  insufficientPermissionsError:
    "Insufficient permissions. Check that you can open the EY Canvas engagement and try again.",
  ApiValidationErrorPreConditionFailedDocument:
    "Could not update EY Canvas. Some documents may have been moved or deleted. Reload the data in a new workbook and try again.",
  ApiValidationFailedWithErrorDocument:
    "Could not update EY Canvas, as some documents had errors. Check the Status column for details.",
  apiServerConnectError:
    "Could not connect to EY Canvas. You may need to be on the EY network to edit this engagement. If the issue persists, contact the Help Desk.",
  apiServerError:
    "An error occurred connecting to EY Canvas. Please try again. If the issue persists, contact the Help Desk.",
  duplicateDocumentNameError: "Duplicate document name",
  APIValidationError:
    "Some records could not be updated in EY Canvas. Check the<b> Status </b>column for details.",
  excelPopulatingMessage:
    "Populating Excel. This may take a few minutes. Do not click on the Excel worksheets until the data has finished loading.",
  generalError:
    "An error occurred. Please reload EY Canvas Bulk Update Add-in and try again.",
  boundSheetAlreadyPopulated:
    "Another EY Canvas Bulk Update Add-in session was already started in this workbook. Try again in a new workbook.",
  excelRenderIssue:
    "Data loading from EY Canvas was interrupted when you clicked on an Excel worksheet. To try again, start an EY Canvas Excel Add-in session in a new workbook.",
  offlineModeLoadingMessage:
    "Opening the EY Canvas Excel Add-in. This may take a few minutes. Do not click on the Excel worksheets until the data has finished loading.",
  offlineModeUserClickError:
    "Opening the EY Canvas Bulk Update Add-in was interrupted when you clicked on an Excel worksheet. To try again, close and re-open the EY Canvas Bulk Update Add-in.",
  inActiveWorkbookError:
    "An error occurred with EY Canvas Bulk Update Add-in. Please open a new workbook and try again. To prevent this error in the future, avoid switching workbooks while data is populating.",
  clientRequestTitleMissing: "Missing Title (required)",
  addclinetRequestTagError:
    "Request created in EY Canvas but tags could not be added. You can manually add the tags in EY Canvas.",
  editclinetRequestTagError:
    "Tags could not be edited for this request. You can manually add or remove tags in EY Canvas.",
  clinetRequestEYContactError:
    "EY contacts could not be edited for this request. You can manually add or remove EY contacts in EY Canvas.",
  forbiddenByEYError:
    "The action taken was forbidden by EY Information Security. Refresh the page and try again. If the issue persists contact the Help Desk.",
  genericErrorMessage:
    "An error occurred with EY Canvas Bulk Update Add-in. Please open a new workbook and try again.",
  itgcName: "IT一般控制名稱（必填）",
  misstatementIndex: "Misstatement index (required)",
  misstatementDescription: "Misstatement description (required)",
  misstatementId: "Misstatement ID",
  controlName: "控制名稱（必填）",
  frequency: "頻率",
  designEffectiveness: "設計有效性",
  controlType: "控制類型",
  controlId: "控制ID",
  operatingEffectiveness: "運行有效性",
  testing: "測試",
  itControlId: "IT控制ID",
  isControlLowerRisk: "控制是否為較低風險？",
  timePhaseName: "Time phase name (required)",
  milestoneRequired: "Milestone (required)",
  startDate: "Start date (YYYY-MM-DD) (required)",
  endDate: "End date (YYYY-MM-DD) (required)",
  keyEvent: "Key event",
  timePhaseId: "時間階段ID",
  startDateFormatError: "Invalid date format in Start date",
  endDateFormatError: "Invalid date format in End date",
  deficiencyTitle: "Deficiency title (required)",
  deficiencyDescription: "Deficiency description (required)",
  deficiencyTitleOriginal: "Deficiency title",
  deficiencyDescriptionOriginal: "Deficiency description",
  deficiencyCategory: "Category",
  deficiencyId: "Deficiency ID",
  deficiencyTitleMaxLimitError: "Deficiency title exceeds 100 character limit",
  deficiencyTitleRequiredError: "Deficiency title is required",
  deficiencyDescriptionMaxLimitError:
    "Deficiency description exceeds 4000 character limit",
  deficiencyDescriptionRequiredError: "Deficiency description is required",
  invalidDeficiencyId: "Invalid Deficiency ID",
  prefix: "前綴",
  suffix: "後綴",
  requiredTitle: "標題（必填）",
  timePhaseRequired: "時間階段（必填）",
  taskGroupRequired: "任務群組（必填）",
  taskGroups: "任務群組",
  customizedDescription: "自訂說明",
  customizedDescriptionRequired: "自訂說明（必填）",
  picSignOffRequired: "PIC簽核",
  eqrSignOffRequired: "EQR簽核",
  invalidDataInTags: "標記中的資料無效",
  taskTags: "標記",
  editTaskAPIError:
    "無法編輯此任務的標記。您可以在EY Canvas中手動新增或刪除標記。",
  engagementLDCVersionUpdateError:
    "EY Canvas 批次更新增益集有可用的更新。請在新的活頁簿中開啟增益集以儲存任務名稱的變更。",
  module: "模組",
  titleForMultiSelectInputMessage: "多選下拉式選單",
  descriptionForMultiSelectInputMessage:
    "請使用右側增益集窗格選擇一個或多個下拉式選項。",
  errorBoundaryMessage:
    "An error has occurred. Please refresh the page and try again. If the issue persists, contact the Help Desk.",
};

// export const instructionSheet={
//  headers:['#','Field Name', 'Additional instructions','To upload as Draft', 'To send to client']

//  }

export const instructionSheetHeader = {
  // reference sheet columns
  count: "#",
  fieldName: "Field name",
  additionalInstructions: "Additional instructions",
  toUploadAsDraft: "To upload as Draft",
  toSaveAsDraft: "To save as Draft",
  toSendToClient: "To send to client",
  bulkUpdateAddIn: "EY Canvas Bulk Update Add-in",
  purpose: "Purpose",
  guidance: "Guidance",
  overView: "Overview of fields",
  required: "Required",
};

export const instructionSheetDataForEditClient = {
  purpose:
    "This tool can be used to bulk edit client requests in EY Canvas Collaboration.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on how to use EY Canvas Collaboration, including how to bulk edit and send requests from EY Canvas Collaboration.",
  additionalInfo:
    "¹ 此為多選下拉式選單欄位。若要編輯此欄位，請使用右側增益集窗格中的下拉式選單。",
  bulkUpdate: "² 請參閱額外說明",
};
export const instructionSheetDataForAddTaskOST = {
  purpose: "此工具可用於將新任務（其他證實性測試）批次上傳到EY Canvas。",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "有關EY Canvas任務分配的更多指引(包括如何在EY Canvas中批次分配任務)請參閱EY Atlas連結。",
  additionalInfo:
    "\u00B9這是一個多重選取的下拉欄位。若要編輯此欄位，請使用右側新增框上的下拉式功能表。",
};
export const instructionSheetDataForEditTasks = {
  purpose: "您可以使用此工具在EY Canvas中批次編輯任務。",
  guidanceHyperlinkforStandardizedIndexing: "標準化索引",
  guidanceforStandardizedIndexing:
    "此工具可用於實現任務的標準化索引管理。有關標準化索引管理的詳細資訊，請參閱EY Atlas指引。",
  guidanceHyperlinkForTaskAssignments: "任務分配",
  guidanceForTaskAssignments:
    "請參閱EY Atlas連結，瞭解有關EY Canvas中任務分配的其他指引，包括如何在EY Canvas中批次分配任務。",
  additionalInfo:
    "\u00B9這是一個多重選取的下拉欄位。若要編輯此欄位，請使用右側新增框上的下拉式功能表。",
};
export const instructionSheetTabularDataForEditTasks = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "點選載入項上的‘更新EY Canvas’按鈕時：\R\n-如點選’是’，記錄將包含在發送到EY Canvas的列表中\r\n-如點選'否’，記錄將從發送到EY Canvas的列表中移除",
    required: "是",
  },
  {
    count: "2",
    fieldName: "前綴",
    additionalInstructions: "使用前綴支援標準化索引的命名規則（最多50個字元）",
    required: "否",
  },
  {
    count: "3",
    fieldName: "標題",
    additionalInstructions:
      "制定一個命名規範，幫助您高效地管理任務（500個字元的限制）",
    required: "是",
  },
  {
    count: "4",
    fieldName: "後綴",
    additionalInstructions: "最多50個字元",
    required: "否",
  },
  {
    count: "5",
    fieldName: "時間階段",
    additionalInstructions: "将任务分配到时间阶段，以支持有效的项目管理",
    required: "是",
  },
  {
    count: "6",
    fieldName: "任務群組",
    additionalInstructions:
      "將工作組織成可管理的任務群組。只能為其他證實性測試編輯任務群組。",
    required: "是",
  },
  {
    count: "7",
    fieldName: "自訂描述",
    additionalInstructions: "描述要針對此任務執行的程序",
    required: "否",
  },
  {
    count: "8",
    fieldName: "標記\u00B9",
    additionalInstructions: "標記是EY Canvas中提供的自訂標籤，可以幫助管理任務",
    required: "否",
  },
  {
    count: "9",
    fieldName: "PIC簽核",
    additionalInstructions:
      "標註任務是否需要PIC簽核。（如果從知識庫中指定PIC簽核，則無法編輯。）",
    required: "否",
  },
  {
    count: "10",
    fieldName: "EQR簽核",
    additionalInstructions:
      "標註任務是否需要EQR簽核。（如果從知識庫中指定EQR簽核，則無法編輯。）",
    required: "否",
  },
];

export const instructionSheetTabularDataForEditClient = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the request in the list sent to EY Canvas \r\n - 'No' will exclude the request from the list sent to EY Canvas",
    toSaveAsDraft: "是",
    toSendToClient: "N/A",
  },
  {
    count: "2",
    fieldName: "標題",
    additionalInstructions:
      "Develop a naming convention that will help you efficiently manage all Requests.",
    toSaveAsDraft: "是",
    toSendToClient: "是",
  },
  {
    count: "3",
    fieldName: "描述",
    additionalInstructions: "The Description has a 4,000 character limit",
    toSaveAsDraft: "否",
    toSendToClient: "否",
  },
  {
    count: "4",
    fieldName: "Assigned to (group)",
    additionalInstructions:
      "Assign the Request to an external user or group.\r\n - To assign to a group, select from Assigned to (group) and leave the next column empty.\r\n - To assign to a specific user, select a user and leave the previous column empty. Users are listed by group.\r\n \r\nNote: All group members will be able to view the request. If a user is in multiple groups, check you are selecting the correct drop-down option.",
    toSaveAsDraft: "否",
    toSendToClient: "One of these is required",
  },
  {
    count: "5",
    fieldName: "Assigned to (user)",
    additionalInstructions: "",
    toSaveAsDraft: "否",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "Due date (YYYY-MM-DD)",
    additionalInstructions:
      "Due date must be specified in YYYY-MM-DD format. If a Due date is not specified but a Time phase is selected, the Due date will default to the end date of the Time phase.",
    toSaveAsDraft: "否",
    toSendToClient: "是\u00B2",
  },
  {
    count: "7",
    fieldName: "安永連絡人\u00B9",
    additionalInstructions:
      "新增安永連絡人，以便外部使用者了解出現問題時應聯繫的人員。當客戶對請求作出回復時，安永連絡人將收到通知。",
    toSaveAsDraft: "否",
    toSendToClient: "否",
  },
  {
    count: "8",
    fieldName: "標記\u00B9",
    additionalInstructions:
      "標籤是指EY Canvas協作中提供的自訂標籤，用於協助管理請求。您可以查看審計團隊及外部使用者應用的標籤。標籤將在EY Canvas協作和EY Canvas Client Portal登入網站之間自動同步。",
    toSaveAsDraft: "否",
    toSendToClient: "否",
  },
  {
    count: "9",
    fieldName: "優先順序",
    additionalInstructions:
      "將請求優先順序設定為高或關鍵，以協助客戶端確定請求優先順序。如果未指定，則請求優先順序預設為正常。",
    toSaveAsDraft: "否",
    toSendToClient: "是\u00B2",
  },
  {
    count: "10",
    fieldName: "時間階段",
    additionalInstructions: "Select a Time phase and/or Due date (see above).",
    toSaveAsDraft: "否",
    toSendToClient: "否",
  },
];

export const instructionSheetData = {
  purpose:
    "This tool can be used to bulk upload new client requests to EY Canvas Collaboration. Requests will be uploaded in 'Draft' status. You can then bulk send requests to the client from EY Canvas Collaboration.",
  guidanceHyperlink: "EY Atlas",
  //  guidanceHyperlink:"<a 'href=https://live.atlas.ey.com/#document/1146470?pref=20052/9/1007&crumb=11'>EY Atlas</a>",
  guidance:
    "Refer to the EY Atlas link for additional guidance on how to use EY Canvas Collaboration, including how to bulk edit and send requests from EY Canvas Collaboration.",
  additionalInfo: "\u00B2請參見附加說明",
  bulkUpdate:
    "\u00B9這是一個多重選取的下拉欄位。若要編輯此欄位，請使用右側新增框上的下拉式功能表。",
};

export const instructionSheetTabularData = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "When you click the 'Update EY Canvas' button on the add-in: \r\n - 'Yes' will include the request in the list sent to EY Canvas \r\n - 'No' will exclude the request from the list sent to EY Canvas",
    toUploadAsDraft: "是",
    toSendToClient: "N/A",
  },
  {
    count: "2",
    fieldName: "標題（必填）",
    additionalInstructions:
      "Develop a naming convention that will help you efficiently manage all Requests.",
    toUploadAsDraft: "是",
    toSendToClient: "是",
  },
  {
    count: "3",
    fieldName: "描述",
    additionalInstructions: "The Description has a 4,000 character limit",
    toUploadAsDraft: "否",
    toSendToClient: "否",
  },
  {
    count: "4",
    fieldName: "Assigned to (group)",
    additionalInstructions:
      "Assign the Request to an external user or group.\r\n - To assign to a group, select from Assigned to (group) and leave the next column empty.\r\n - To assign to a specific user, select a user and leave the previous column empty. Users are listed by group.\r\n \r\nNote: All group members will be able to view the request. If a user is in multiple groups, check you are selecting the correct drop-down option.",
    toUploadAsDraft: "否",
    toSendToClient: "One of these is required",
  },
  {
    count: "5",
    fieldName: "Assigned to (user)",
    additionalInstructions: "",
    toUploadAsDraft: "否",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "Due date (YYYY-MM-DD)",
    additionalInstructions:
      "Due date must be specified in YYYY-MM-DD format. If a Due date is not specified but a Time phase is selected, the Due date will default to the end date of the Time phase.",
    toUploadAsDraft: "否",
    toSendToClient: "是\u00B2",
  },
  {
    count: "7",
    fieldName: "安永連絡人\u00B9",
    additionalInstructions:
      "新增安永連絡人，以便外部使用者了解出現問題時應聯繫的人員。當客戶對請求作出回復時，安永連絡人將收到通知。",
    toUploadAsDraft: "否",
    toSendToClient: "否",
  },
  {
    count: "8",
    fieldName: "標記\u00B9",
    additionalInstructions:
      "標籤是指EY Canvas協作中提供的自訂標籤，用於協助管理請求。您可以查看審計團隊及外部使用者應用的標籤。標籤將在EY Canvas協作和EY Canvas Client Portal登入網站之間自動同步。",
    toUploadAsDraft: "否",
    toSendToClient: "否",
  },
  {
    count: "9",
    fieldName: "優先順序",
    additionalInstructions:
      "將請求優先順序設定為高或關鍵，以協助客戶端確定請求優先順序。如果未指定，則請求優先順序預設為正常。",
    toUploadAsDraft: "否",
    toSendToClient: "是\u00B2",
  },
  {
    count: "10",
    fieldName: "時間階段",
    additionalInstructions: "Select a Time phase and/or Due date (see above).",
    toUploadAsDraft: "否",
    toSendToClient: "否",
  },
];

export const instructionSheetStaticDataITGC = {
  purpose: "您可以使用此工具在EY Canvas中批量編輯IT一般控制詳情。",
  additionalInfo:
    "\u002A如果已在EY Canvas中指定了一項值，則該值可以更改，但不能刪除。",
};
export const instructionSheetStaticDataMisstatement = {
  purpose:
    "This tool can be used to bulk edit misstatement details in EY Canvas.",
  additionalInfo:
    "\u002A如果已在EY Canvas中指定了一項值，則該值可以更改，但不能刪除。",
};
export const instructionSheetDataForMisstatements = {
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on misstatements and summary of audit differences.",
};
export const instructionSheetTabularDataMisstatement = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "點選載入項上的‘更新EY Canvas’按鈕時\R\n-如點選’是’，記錄將包含在發送到EY Canvas的列表中\r\n-如點選'否’，記錄將從發送到EY Canvas的列表中移除",
    required: "是",
  },
  {
    count: "2",
    fieldName: "Misstatement index",
    additionalInstructions: "Unique identifier for the misstatement (100 character limit)",
    required: "是",
  },
  {
    count: "3",
    fieldName: "Misstatement description",
    additionalInstructions:
      "Description of the misstatement (500 character limit)\n",
    required: "是",
  },
];
export const instructionSheetStaticDataAddTaskOST = {
  purpose: "此工具可用於將新任務（其他證實性測試）批次上傳到EY Canvas。",
  additionalInfo:
    "\u002A如果已在EY Canvas中指定了一項值，則該值可以更改，但不能刪除。",
};
export const instructionSheetTabularDataForAddTaskOST = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "點選載入項上的‘更新EY Canvas’按鈕時：\R\n-如點選’是’，記錄將包含在發送到EY Canvas的列表中\r\n-如點選'否’，記錄將從發送到EY Canvas的列表中移除",
    required: "是",
  },
  {
    count: "2",
    fieldName: "前綴",
    additionalInstructions: "使用前綴支援標準化索引的命名規則（最多50個字元）",
    required: "否",
  },
  {
    count: "3",
    fieldName: "標題",
    additionalInstructions:
      "制定一個命名規範，幫助您高效地管理任務（500個字元的限制）",
    required: "是",
  },
  {
    count: "4",
    fieldName: "後綴",
    additionalInstructions: "最多50個字元",
    required: "否",
  },
  {
    count: "5",
    fieldName: "時間階段",
    additionalInstructions: "将任务分配到时间阶段，以支持有效的项目管理",
    required: "是",
  },
  {
    count: "6",
    fieldName: "任務群組",
    additionalInstructions: "將工作整理成可管理的任務群組",
    required: "是",
  },
  {
    count: "7",
    fieldName: "自訂描述",
    additionalInstructions: "描述要針對此任務執行的程序",
    required: "是",
  },
  {
    count: "8",
    fieldName: "標記\u00B9",
    additionalInstructions: "標記是EY Canvas中提供的自訂標籤，可以幫助管理任務",
    required: "否",
  },
  {
    count: "9",
    fieldName: "PIC簽核",
    additionalInstructions: "標註任務是否需要PIC簽核",
    required: "否",
  },
  {
    count: "10",
    fieldName: "EQR簽核",
    additionalInstructions: "標註任務是否需要EQR簽核",
    required: "否",
  },
];
export const instructionSheetStaticDataControl = {
  purpose: "您可以使用此工具在EY Canvas中批量編輯控制詳情。",
  additionalInfo:
    "\u002A如果已在EY Canvas中為此欄位指定了一項值，則該值可以更改，但不能刪除。",
};

export const instructionSheetStaticDataTimePhase = {
  purpose:
    "This tool can be used to bulk edit time phases details in EY Canvas.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on the Milestones Program, which promotes effective project management and timely audit pacing. Teams can associate time phases to each milestone to plan completion of audit work by scheduled deadlines and mitigate the potential for undue compression during the year-end reporting cycle.",
};

export const instructionSheetTabularDataTimePhase = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "點選載入項上的‘更新EY Canvas’按鈕時：\R\n-如點選’是’，記錄將包含在發送到EY Canvas的列表中\r\n-如點選'否’，記錄將從發送到EY Canvas的列表中移除",
    required: "是",
  },
  {
    count: "2",
    fieldName: "時間階段名稱",
    additionalInstructions: "500 character limit",
    required: "是",
  },
  {
    count: "3",
    fieldName: "Milestone",
    additionalInstructions: "Select a milestone from the drop-down list",
    required: "是",
  },
  {
    count: "4",
    fieldName: "開始日",
    additionalInstructions: "Must be specified in YYYY-MM-DD format",
    required: "是",
  },
  {
    count: "5",
    fieldName: "結束日",
    additionalInstructions: "Must be specified in YYYY-MM-DD format",
    required: "是",
  },
  {
    count: "6",
    fieldName: "Key event",
    additionalInstructions:
      "Indicate if this milestone is a key event in the completion of audit work",
    required: "否",
  },
];

export const instructionSheetTabularDataITGC = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "點選載入項上的‘更新EY Canvas’按鈕時：\R\n-如點選’是’，記錄將包含在發送到EY Canvas的列表中\r\n-如點選'否’，記錄將從發送到EY Canvas的列表中移除",
    required: "是",
  },
  {
    count: "2",
    fieldName: "IT一般控制名稱（必填）",
    additionalInstructions: "IT一般控制名稱的字元上限為500",
    required: "是",
  },
  {
    count: "3",
    fieldName: "頻率",
    additionalInstructions: "從下拉清單中選擇控制頻率",
    required: "否\u002A",
  },
  {
    count: "4",
    fieldName: "設計有效性",
    additionalInstructions:
      "如果已完成設計有效性程序，則說明結論（有效或無效）",
    required: "否",
  },
  {
    count: "5",
    fieldName: "運行有效性",
    additionalInstructions:
      "如果已完成運行有效性程序，則說明結論（有效或無效）",
    required: "否",
  },
  {
    count: "6",
    fieldName: "測試",
    additionalInstructions: "說明我們是否計畫測試此控制",
    required: "否",
  },
];

export const instructionSheetTabularDataControl = [
  {
    count: "1",
    fieldName: "更新EY Canvas",
    additionalInstructions:
      "點選載入項上的‘更新EY Canvas’按鈕時：\R\n-如點選’是’，記錄將包含在發送到EY Canvas的列表中\r\n-如點選'否’，記錄將從發送到EY Canvas的列表中移除",
    required: "是",
  },
  {
    count: "2",
    fieldName: "控制名稱（必填）",
    additionalInstructions: "控制名稱的字元上限為500",
    required: "是",
  },
  {
    count: "3",
    fieldName: "頻率",
    additionalInstructions: "從下拉清單中選擇控制頻率",
    required: "否\u002A",
  },
  {
    count: "4",
    fieldName: "控制類型",
    additionalInstructions: "從下拉清單中選擇控制類型",
    required: "否\u002A",
  },
  {
    count: "5",
    fieldName: "設計有效性",
    additionalInstructions:
      "如果已完成設計有效性程序，則說明結論（有效或無效）",
    required: "否",
  },
  {
    count: "6",
    fieldName: "運行有效性",
    additionalInstructions:
      "如果已完成運行有效性程序，則說明結論（有效或無效）",
    required: "否",
  },
  {
    count: "7",
    fieldName: "測試",
    additionalInstructions: "說明我們是否計畫測試此控制",
    required: "否",
  },
  {
    count: "8",
    fieldName: "控制是否為較低風險？",
    additionalInstructions: "指出控制是否風險較低",
    required: "否",
  },
];

export const errors = {
  14057: "Duplicate document name",
  14084: "Document name cannot contain */:<>\\?|" + '"',
  14085: "Document name cannot exceed 115 characters",
  14086: "DocService failed while updating document details.",
  14088: "Duplicate document name",
  5166: "Task title cannot be edited for this task type",
  5170: "Exceeds character limit (title: 500 characters; prefix/suffix: 50 characters)",
  5169: "Exceeds character limit (title: 500 characters; prefix/suffix: 50 characters)",
  5047: "Exceeds character limit (title: 500 characters; prefix/suffix: 50 characters)",
  5018: "Task deleted or rejected in EY Canvas",
  14071: "File name is required",
  14054: "File name is required",
  409: "Duplicate document name",
  21071:
    "Count of client requests sent in the body exceeds the maximum allowed limit.",
  21041: "標題超出500個字元的上限",
  21076: "Invalid data in Priority",
  21042: "描述超出4000個字元的上限",
  21072: "Invalid data in Due date",
  21027: "Missing Title (required)",
  21039: "Assign the request to a valid group/user",
  21032: "Assign the request to a valid group/user",
  21034: "Client Group does not have active users",
  21035: "Request not found in EY Canvas",
  21036: "Invalid data in Time phase",
  21057:
    "EY Contact is not a member of the engagement, is not Active, or is Independence-only",
  21073:
    "One or more data in Request payload is not valid. Please verify the data and try again.",
  21074: "Cannot change Title, Description, or Priority for Received requests",
  21075:
    "Cannot change Title, Description, Assigned to (group), Assigned to (user), Due date, Priority or Timephase for Accepted requests",
  21076: "PriorityTypeId enum does not contain 1, 2 or 3",
  21077: "Specify a due date in YYYY-MM-DD format",
  21078:
    "Group and User are both required, when updating either Assigned To Group or Assigned To User",
  21079: "Specify a due date in YYYY-MM-DD format",
  21080: "Due date is required, when Timephase is available",
  21081: "EY Contact(s) is not valid or includes duplicates",
  25000: "Specify a time phase",
  26000: "Specify a due date in YYYY-MM-DD format",
  84006: "IT一般控制名稱為必填項",
  84007: "IT一般控制名稱超過500字元上限",
  84008: "頻率中的資料無效",
  84029: "頻率中的資料無效",
  84010: "設計有效性中的資料無效",
  84027: "測試中存在無效資料",
  84028: "測試中的資料無效",
  84031: "如果測試=否，則無法就執行有效性得出結論",
  84032: "設計有效性中的資料無效",
  84004: "IT控制ID無效",
  37007: "Misstatement index is required",
  37009: "Misstatement description is required",
  37130: "Misstatement description exceeds 500 character limit",
  37036: "Invalid Misstatement ID",
  37072: "Misstatement index exceeds 100 character limit",
  83018: "控制名稱超過500字元上限",
  83004: "控制ID無效",
  83006: "控制名稱為必填",
  83009: "頻率中的資料無效",
  83010: "控制類型中的資料無效",
  83031: "是否為人工測試的IPE中的資料無效",
  83012: "設計有效性中的資料無效",
  83033: "執行有效性的資料無效",
  83034: "測試中的資料無效",
  85004: "Invalid Deficiency ID",
  85006: "Deficiency title is required",
  85018: "Deficiency title exceeds 100 character limit",
  85019: "Deficiency description is required",
  85042: "Deficiency description exceeds 4000 character limit",
  5169: "前綴超出50個字元的上限",
  5170: "後綴超出50個字元的上限",
  5047: "標題超出500個字元的上限",
  5108: "描述超出4000個字元的上限",
  5059: "時間階段中的資料無效（必填）",
  5111: "任務群組中的資料無效（必填）",
  5051: "任務群組中的資料無效（必填）",
  5019: "自訂描述（必填）為必填",
  5103: "標題（必填）為必填",
  5104: "時間階段（必填）為必填",
  5109: "任務群組（必填）為必填",
  5203: "必須經PIC簽核",
  5204: "必須經EQR簽核",
  5202: "無法更改任務群組",
  5168: "標題（必填）為必填",
  16003: "Invalid Time phase ID",
  16006: "Invalid data in Time phase name (required)",
  16007: "Invalid data in Milestone",
  16008: "Invalid data in Start date",
  16009: "Invalid data in End date",
  16010: "Time phase name (required) is required",
  16022: "Specify a date later than 1900-01-01",
  16023: "End date must be on or after the Start date",
  16024: "Key event is required",
  16025: "Start date must be on or before the End date",
  16026: "Time phase deleted or not found in EY Canvas",
  16027: "Time phase name exceeds 500 character limit",
  16028: "Milestone (required) is required",
  16029: "Start date (YYYY-MM-DD) (required) is required",
  16030: "End date (YYYY-MM-DD) (required) is required",
};

export const milestonesLabels = {
  1: "Scope",
  2: "Strategy",
  3: "Walkthroughs",
  4: "Interim control testing",
  5: "Interim substantive testing",
  6: "Walkthroughs (year-end processes)",
  7: "Year-end control testing",
  8: "Year-end substantive testing",
  9: "Conclusion",
  10: "Not applicable",
  11: "Execution",
  12: "Group audit S&S",
  13: "Preliminary planning",
  14: "CRA",
  15: "Identify and assess risk",
  16: "Design response to risk",
  17: "Post-interim project management",
};

export const clientRequestStatusType = {
  1: "Draft",
  2: "Draft",
  5: "Draft",
  10: "Draft",
  11: "Draft",
  14: "Draft",
  17: "Draft",
  6: "Pending response",
  9: "Pending response",
  13: "Pending response",
  16: "Pending response",
  20: "Pending response",
  21: "Pending response",
  27: "Pending response",
  7: "Received",
  12: "Received",
  15: "Received",
  18: "Received",
  19: "Received",
  8: "Accepted",
  28: "Accepted",
};

export const filterAuditPhases = {
  1: "Scope & strategy",
  2: "Execution",
  3: "Conclusion",
};

export const taskTypeAbbreviation = {
  1: "TOC",
  2: "TOC",
  3: "TOC",
  4: "TOC",
  5: "TOC",
  6: "TOC",
  7: "RT",
  8: "RT",
  9: "RT",
  10: "RT",
  11: "RT",
  12: "OST",
  13: "OST",
  14: "PST",
  15: "OSP",
  16: "OSP",
  17: "PSP",
  18: "UDP",
  19: "UDP",
  20: "UDP",
  21: "UDP",
  22: "ACT",
  23: "GT",
  24: "GT",
  25: "GT",
  26: "OSP",
  27: "GT",
  28: "UDP",
  29: "EDC",
  30: "UDP",
  31: "UDP",
  32: "EDC",
  34: "RT",
};

export const uploadStatusLabels = {
  1: "Pending sync", //pending
  2: "Offline edited", //offlineEdit
  3: "Downloaded", //downloaded
  4: "Uploaded", //uploaded
  5: "Invalid Input", //invalidInput
  6: "Server Error", //serverError
  7: "Unexpected API Error", //unexpectedAPIError
  8: "Client Fetch Error", //clientFetchError
  9: "Post Processing Error", //postProcessingError
};

export const clientrequestRefSheetMainHeaders = {
  // reference sheet columns
  updateEyCanvas: "更新EY Canvas",
  priority: "優先順序",
  assignedToGroups: "Assigned to (group)",
  assignedToUsers: "Assigned to (user)",
  eyContacts: "EY contact",
  tags: "標記",
  timephases: "Time phases",
};

export const OstTaskReferenceSheetColumns = {
  updateEyCanvas: "更新EY Canvas",
  timePhase: "時間階段",
  taskGroup: "任務群組",
  tags: "標記",
  timephasename: "時間階段名稱",
  startDate: "開始日",
  endDate: "結束日",
  timePhaseId: "時間階段ID",
  taskGroupName: "任務群組名稱",
  auditPhase: "審計階段",
  groupName: "集團名稱",
  taskGroupId: "任務群組ID",
  tagDescription: "描述",
  tagGroup: "標記群組",
  tagLabel: "標記",
  tagColor: "顏色",
  tagId: "標記ID",
  signOff: "簽核",
  signOffValue: "簽核值",
};

export const clientrequestInputSheetMainHeaders = {
  clientRequestTitle: "標題（必填）",
  clientRequestDescription: "描述",
  AssignedToGroup: "Assigned to (group)",
  AssignedToUser: "Assigned to (user)",
  DueDate: "Due date (YYYY-MM-DD)",
  eyContact: "EY contact",
  tags: "標記",
  priority: "優先順序",
  requestGuid: "ClientRequest GUID",
  requestId: "ClientRequestID",
  statusID: "Status ID",
  timephases: "時間階段",
  requestHash: "Request #",
  requestHashSpace: "Request # ",
  clientRequestTitleSpace: "標題（必填）",
  clientRequestDescriptionSpace: "描述",
  AssignedToGroupSpace: "Assigned to (group) ",
  AssignedToUserSpace: "Assigned to (user) ",
  DueDateSpace: "Due date (YYYY-MM-DD) ",
  eyContactSpace: "EY contact ",
  tagsSpace: "標記",
  prioritySpace: "優先順序",
  timephasesSpace: "時間階段",
  requestStatusId: "Request status ID",
  requestStatus: "Request status",
};

export const clientrequestRefSheetSubHeaders = {
  priority: {
    priorityName: "Priority name",
    priorityTypeId: "Priority type ID",
  },
  assignedToGroups: {
    group: "Group",
    groupName: "集團名稱",
    groupId: "Group ID",
  },
  assignedToUsers: {
    groupMember: "Group member",
    name: "Name",
    groupName: "集團名稱",
    userId: "User ID",
    groupId: "Group ID",
  },
  eyContacts: {
    name: "Name",
    userId: "User ID",
  },
  tags: {
    tagName: "標記",
    colorCode: "顏色",
    engagementTagName: "描述",
    engagementTagID: "標記ID",
  },
  timephases: {
    timePhaseName: "時間階段",
    periodName: "時間階段名稱",
    startDate: "開始日",
    dueDate: "結束日",
    timephaseId: "時間階段ID",
  },
};

export const priorityTypesCollaboration = [
  {
    value: 1,
    label: "Normal",
  },
  {
    value: 3,
    label: "High",
  },
  {
    value: 4,
    label: "Critical",
  },
];

export const ButtonOptions = [
  {
    label: "Edit document names",
    activeButton: "active-btn",
    id: 1,
    DisplayOrder: 4,
  },
  {
    label: "Create draft client requests",
    activeButton: "active-btn",
    id: 3,
    DisplayOrder: 1,
  },
  {
    label: "Edit client requests",
    activeButton: "active-btn",
    id: 4,
    DisplayOrder: 2,
  },
  {
    label: "編輯IT一般控制",
    activeButton: "active-btn",
    id: 5,
    DisplayOrder: 5,
  },
  {
    label: "編輯任務",
    activeButton: "active-btn",
    id: 2,
    DisplayOrder: 8,
  },
  {
    label: "Edit time phases",
    activeButton: "active-btn",
    id: 8,
    DisplayOrder: 9,
  },
  {
    label: "編輯控制",
    activeButton: "active-btn",
    id: 6,
    DisplayOrder: 3,
  },
  {
    label: "建立任務（其他證實性測試）",
    activeButton: "active-btn",
    id: 7,
    DisplayOrder: 7,
  },
  {
    label: "Edit misstatements",
    activeButton: "active-btn",
    id: 9,
    DisplayOrder: 6,
  },
  {
    label: "Edit deficiencies",
    activeButton: "active-btn",
    id: 10,
    DisplayOrder: 10,
  },
];

export const ClientRequestTypeOptions = [
  {
    label: "Draft",
    id: 1,
    apiPayload: "Draft",
  },
  {
    label: "Pending response",
    id: 2,
    apiPayload: "Pending",
  },
  {
    label: "Received",
    id: 3,
    apiPayload: "Received",
  },
  {
    label: "Accepted",
    id: 4,
    apiPayload: "Accepted",
  },
];

export const colorOptionsLabels = [
  {
    value: "Red",
    label: "Red",
  },
  {
    value: "Orange",
    label: "Orange",
  },
  {
    value: "Teal",
    label: "Teal",
  },
  {
    value: "Blue",
    label: "Blue",
  },
  {
    value: "Purple",
    label: "Purple",
  },
  {
    value: "Green",
    label: "Green",
  },
  {
    value: "Yellow",
    label: "Yellow",
  },
  {
    value: "Gray",
    label: "Gray",
  },
];

export const controlFrequencyNameTypes = [
  {
    id: 1,
    value: 1,
    label: "每日多次",
  },
  {
    id: 2,
    value: 2,
    label: "每日",
  },
  {
    id: 3,
    value: 3,
    label: "每週",
  },
  {
    id: 4,
    value: 4,
    label: "每月",
  },
  {
    id: 5,
    value: 5,
    label: "每季",
  },
  {
    id: 6,
    value: 6,
    label: "每年",
  },
  {
    id: 8,
    value: 8,
    label: "其他",
  },
];

export const controlDesignEffectivenessType = [
  {
    id: 1,
    value: 1,
    label: "有效",
  },
  {
    id: 2,
    value: 2,
    label: "無效",
  },
];

export const operativeEffectivenessType = [
  {
    id: true,
    value: true,
    label: "有效",
  },
  {
    id: false,
    value: false,
    label: "無效",
  },
];

export const BooleanType = [
  {
    id: true,
    value: true,
    label: "true",
  },
  {
    id: false,
    value: false,
    label: "錯誤",
  },
];

export const YesNoTypes = [
  {
    id: true,
    value: 1,
    booleanValue: true,
    label: "是",
  },
  {
    id: false,
    value: 0,
    booleanValue: false,
    label: "否",
  },
];

export const controlTypes = [
  {
    id: 1,
    value: 1,
    label: "IT應用程式控制",
  },
  {
    id: 2,
    value: 2,
    label: "仰賴IT的人工控制",
  },
  {
    id: 3,
    value: 3,
    label: "人工預防",
  },
  {
    id: 4,
    value: 4,
    label: "人工偵測",
  },
];

// Mirrors filterMilestones in EY Canvas web: ordered the way EY Canvas displays milestones rather than by id,
// omitting Scope (1), Strategy (2) and "No milestone" (0) because EY Canvas hides those from this dropdown.
export const timephaseTypes = [
  {
    id: 12,
    value: 12,
    label: "Group audit S&S",
  },
  {
    id: 13,
    value: 13,
    label: "Preliminary planning",
  },
  {
    id: 14,
    value: 14,
    label: "CRA",
  },
  {
    id: 15,
    value: 15,
    label: "Identify and assess risk",
  },
  {
    id: 16,
    value: 16,
    label: "Design response to risk",
  },
  {
    id: 17,
    value: 17,
    label: "Post-interim project management",
  },
  {
    id: 3,
    value: 3,
    label: "Walkthroughs",
  },
  {
    id: 4,
    value: 4,
    label: "Interim control testing",
  },
  {
    id: 5,
    value: 5,
    label: "Interim substantive testing",
  },
  {
    id: 6,
    value: 6,
    label: "Walkthroughs (year-end processes)",
  },
  {
    id: 7,
    value: 7,
    label: "Year-end control testing",
  },
  {
    id: 8,
    value: 8,
    label: "Year-end substantive testing",
  },
  {
    id: 11,
    value: 11,
    label: "Execution",
  },
  {
    id: 9,
    value: 9,
    label: "Conclusion",
  },
  {
    id: 10,
    value: 10,
    label: "N/A",
  },
];

export const deficiencyCategoryTypes = [
  {
    id: 19,
    value: 19,
    label: "Business process",
  },
  {
    id: 34,
    value: 34,
    label: "IT process",
  },
];
